import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// import { Manager, Target, Popper } from "react-popper";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Hidden from "@material-ui/core/Hidden";
import Popper from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
import Badge from "@material-ui/core/Badge";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
import Dashboard from "@material-ui/icons/Dashboard";

import { useHistory } from "react-router-dom";
import moment from "moment";
// core components
import Button from "./Button2.js";

import styles from "./adminNavbarLinksStyle.js";
import { useAlert } from "./Alert";

const GET_PERSONALMESSAGES = gql`
  query personalMessages(
    $id: Int
    $type: PersonalMessageType
    $readed: Boolean
    $searchTerm: String
    $latest: Boolean
    $status: AssignmentStatus
    $pageSize: Int
    $page: Int
  ) {
    personalMessages(
      id: $id
      type: $type
      readed: $readed
      searchTerm: $searchTerm
      latest: $latest
      status: $status
      pageSize: $pageSize
      page: $page
    ) {
      count
      contents {
        id
        category {
          id
          name
          createdAt
          updatedAt
        }
        task
        response
        status
        statusUpdatedAt
        expectedFinishedAt
        shouldFinishAt
        finishedAt
        assignTo {
          id
          fullName
        }
        assignedBy {
          id
          fullName
        }
        updatedBy {
          id
          fullName
        }
        nameOfReservation
        customer {
          id
        }
        user {
          id
        }
        reservation
        content
        foreclosureUpdateLog
        type
        readed
        createdAt
        updatedAt
      }
    }
  }
`;

const CHANGE_PERSONALMESSAGEREADED = gql`
  mutation changePersonalMessageReaded($id: Int!) {
    changePersonalMessageReaded(id: $id)
  }
`;

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const Alert = useAlert();
  const history = useHistory();
  const [openNotification, setOpenNotification] = React.useState(null);
  const handleClickNotification = (event) => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);
    } else {
      setOpenNotification(event.currentTarget);
    }
  };
  const handleCloseNotification = () => {
    setOpenNotification(null);
  };
  const [openProfile, setOpenProfile] = React.useState(null);
  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = (value) => {
    setOpenProfile(null);
    if (value === "Logout") {
      Alert.alert("通知", "確定要登出？", [
        {
          text: "確定",
          onPress: () => {
            localStorage.clear();
            history.replace("/console/login");
          },
          type: "ok",
        },
        {
          text: "取消",
          type: "cancel",
        },
      ]);
    }
  };
  const classes = useStyles();
  const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover);
  const wrapper = classNames();
  const managerClasses = classNames({
    [classes.managerClasses]: true,
  });

  const { data, refetch } = useQuery(GET_PERSONALMESSAGES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    pollInterval: 10000,
    variables: {
      id: Number(localStorage.getItem("@fullhouseUserId")),
      readed: false,
    },
  });

  const [changePersonalMessageReaded] = useMutation(
    CHANGE_PERSONALMESSAGEREADED
  );
  return (
    <div className={wrapper}>
      {/* <Button
        color="transparent"
        simple
        aria-label="Dashboard"
        justIcon
        className={classes.buttonLink}
        muiClasses={{
          label: "",
        }}
      >
        <Dashboard
          className={
            classes.headerLinksSvg +
            " " +
            (classes.links)
          }
        />
        <Hidden mdUp implementation="css">
          <span className={classes.linkText}>
            {"Dashboard"}
          </span>
        </Hidden>
      </Button> */}
      <div className={managerClasses}>
        <Button
          color="transparent"
          justIcon
          aria-label="Notifications"
          aria-owns={openNotification ? "notification-menu-list" : null}
          aria-haspopup="true"
          onClick={handleClickNotification}
          className={classes.buttonLink}
          muiClasses={{
            label: "",
          }}
        >
          <Notification data={data} />
          {/* <span className={classes.notifications}>5</span> */}
          <Hidden mdUp implementation="css">
            <span
              onClick={handleClickNotification}
              className={classes.linkText}
            >
              {"Notification"}
            </span>
          </Hidden>
        </Button>
        <Popper
          open={Boolean(openNotification)}
          anchorEl={openNotification}
          transition
          disablePortal
          placement="bottom"
          className={classNames({
            [classes.popperClose]: !openNotification,
            [classes.popperResponsive]: true,
            [classes.popperNav]: true,
          })}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id="notification-menu-list"
              style={{ transformOrigin: "0 0 0" }}
            >
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={handleCloseNotification}>
                  <MenuList role="menu">
                    {data?.personalMessages.contents.map((item, index) => {
                      return (
                        <MenuItem
                          className={dropdownItem}
                          onClick={() => {
                            changePersonalMessageReaded({
                              variables: { id: item.id },
                            });
                            refetch();
                            handleCloseNotification();
                            switch (item.type) {
                              case "ASSIGNMENT":
                                return history.replace("/console/assignments");
                              case "RESERVATION":
                                if (item.customer)
                                  localStorage.setItem(
                                    "@fullhouseCustomer",
                                    item.customer.id
                                  );
                                else
                                  localStorage.setItem(
                                    "@fullhouseCustomer",
                                    item.user.id
                                  );
                                return history.replace(
                                  "/console/customer-center"
                                );
                              case "FORECLOSUREUPDATE":
                                return history.replace("/console/new-favorite");
                              default:
                                break;
                            }
                          }}
                        >
                          {(() => {
                            switch (item.type) {
                              case "FORECLOSUREUPDATE":
                                return `${index + 1}. ${
                                  item.foreclosureUpdateLog
                                }`;
                              case "ASSIGNMENT":
                                return `${index + 1}. 狀態更新時間：${moment(
                                  item.updatedAt
                                ).format("yyyy/MM/DD")}，工作內容：${
                                  item.task
                                }，最後更新者：${
                                  item.updatedBy.fullName
                                }，狀態：${(() => {
                                  switch (item.status) {
                                    case "PENDING":
                                      return "未進行";
                                    case "TO_BE_DECIDED":
                                      return "待決策";
                                    case "IN_PROGRESS":
                                      return "進行中";
                                    case "FINISHED":
                                      return "已完成";
                                    default:
                                      break;
                                  }
                                })()}，狀態說明：${item.response ?? ""}`;
                              case "RESERVATION":
                                return `${index + 1}. 客戶：${
                                  item.nameOfReservation
                                }，${moment(item.reservation).format(
                                  "yyyy/MM/DD"
                                )}，${item.content}`;
                              default:
                                return null;
                            }
                          })()}
                        </MenuItem>
                      );
                    })}
                    <MenuItem
                      onClick={() =>
                        history.replace("/console/personal-message")
                      }
                      className={dropdownItem}
                    >
                      查看更多...
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>

      <div className={managerClasses}>
        <Button
          color="transparent"
          aria-label="Person"
          justIcon
          aria-owns={openProfile ? "profile-menu-list" : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={classes.buttonLink}
          muiClasses={{
            label: "",
          }}
        >
          <Person className={classes.headerLinksSvg + " " + classes.links} />
          <Hidden mdUp implementation="css">
            <span onClick={handleClickProfile} className={classes.linkText}>
              {"Profile"}
            </span>
          </Hidden>
        </Button>
        <Popper
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          placement="bottom"
          className={classNames({
            [classes.popperClose]: !openProfile,
            [classes.popperResponsive]: true,
            [classes.popperNav]: true,
          })}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list"
              style={{ transformOrigin: "0 0 0" }}
            >
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                    {/* <MenuItem
                      onClick={handleCloseProfile}
                      className={dropdownItem}
                    >
                      {"Profile"}
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseProfile}
                      className={dropdownItem}
                    >
                      {"Settings"}
                    </MenuItem>
                    <Divider light /> */}
                    <MenuItem
                      onClick={() => handleCloseProfile("Logout")}
                      className={dropdownItem}
                    >
                      {"登出"}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
}

function Notification({ data }) {
  const classes = useStyles();

  return (
    <Badge
      color="secondary"
      badgeContent={data?.personalMessages.count}
      max={10}
    >
      <Notifications className={classes.headerLinksSvg + " " + classes.links} />
    </Badge>
  );
}

HeaderLinks.propTypes = {};
